// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"starRating_wrapper__3J1-_","starCon":"starRating_starCon__2Rixl","star":"starRating_star__2b2TX","selected":"starRating_selected__1u01A"};